module.exports = __webpack_public_path__ + "img/ennetix-transactions.acb57d38.png";